module.exports = __webpack_public_path__ + "img/logo.409f910d.png";